import React, {useCallback, useEffect} from "react";
import {validateCondition} from "../../scripts/validation";
import {MM_QUESTION} from "../../scripts/myga-model";
import SubQuestions from "./SubQuestions";
import {PROCESS_COL_LIMIT, PROCESS_QUESTION_TEXT} from "../../scripts/layout-manager";
import {isValid} from "../../scripts/myga-session";
import useWindowWidthResize from "../../scripts/UseWindowWidthResize";

/**
 * Question with multiple checkbox responses.
 * State is handled by the caller so that the component is re-rendered
 * on each checkbox click.
 * At least one checkbox is required
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function QuestionMultiCheckbox(props) {
  
  const {data, question, handleChange, handleClick, cols, required, responseClass, mode} = props;

  const responses = question.response[MM_QUESTION.response.constraints];
  // const spacingClassName = props.spacingClassName || MM_ColClassNameForQuestion(question);
  // const colSpan = cols ? Math.floor(12 / cols) : 6;
  // const colCount = Math.floor(12 / colSpan);
  // const mdColOff = colCount > 2 ? 1 : colCount > 1 ? 2 : 3;
  const questions = question.questions || [];
  // NassauLog(`colSpan: ${colSpan}, colCount: ${colCount}, mdColOff: ${mdColOff}`);
  
  // const required = (responses.findIndex((config)=>{
  //   const section = data[config.section] || data;
  //   return section[config.key]==='Yes';
  // })<0);
  //
  // Need a nice way to reset the checkboxes if any are disabled.
  useEffect(()=>{
    responses.forEach((config)=>{
      const section = data[config.section] || data;
      const checked = section[config.key]==='Yes';
      const disabled = !validateCondition(config.enableCondition,data);
      // if we are disabled and checked then uncheck
      if (disabled && checked) {
        handleClick(config.key)('No');
      }
    })
  },[data,responses,handleClick]);
  
  
  const localHandleClick = useCallback(key => e => {
    if (mode==='radio') {
      if (e.target.checked) {
        responses.forEach(r => {
          if (r.key !== e.target.id) handleClick(r.key)('No');
        })
      }
    }
    handleClick(key)(e);
  }, [mode, handleClick, responses]);
  // const handleClickByMode = useCallback(())
  
  // const checkBox = (config) => {
  //   const section = data[config.section] || data;
  //   const checked = section[config.key]==='Yes';
  //   const disabled = !validateCondition(config.enableCondition,data);
  //   return (
  //       <div style={{flexBasis: '50%'}} className="text-left pl-0 pr-0" key={config.key}>
  //         <div className="form-check form-check-inline">
  //           <input
  //               required={required}
  //               disabled={disabled}
  //               type="checkbox"
  //               className="form-check-input"
  //               id={config.key}
  //               checked={checked}
  //               onClick={handleClick(config.key)}
  //               onChange={() => {}}
  //           />
  //           <label className="form-check-label" htmlFor={config.key}>&nbsp;{config.text}</label>
  //         </div>
  //         <SubQuestions questions={questions}
  //                       parentKey={config.key}
  //                       handleChange={handleChange}
  //                       data={data}
  //         />
  //       </div>
  //   )
  // }

  const grid = (response) => {
    const section = data[response.section] || data;
    const checked = section[response.key]==='Yes';
    const disabled = !validateCondition(question.enableCondition,data) || !validateCondition(response.enableCondition,data);
    let leftPadding = 'pl-0';
    if (question.response.justification === 'center') {
      leftPadding = 'pl-5';
    }
    return (
      <div className={`text-left ${leftPadding} pr-5`} key={response.key}>
        <div className="form-check form-check-inline">
          <input
            required={required}
            disabled={disabled}
            type="checkbox"
            className="form-check-input"
            id={response.key}
            checked={checked}
            onClick={localHandleClick(response.key)}
            // onClick={handleClick(response.key)}
            onChange={() => {}}
          />
          <label className="form-check-label pl-2" htmlFor={response.key}>{PROCESS_QUESTION_TEXT(response)}</label>
        </div>
        <SubQuestions questions={questions}
                      anchorTo={response.key}
                      handleChange={handleChange}
                      data={data}
        />
      </div>
    )
  }

  const handleColCount = () => isValid(question.response.colCount) ? `colCount-${PROCESS_COL_LIMIT(question.response.colCount)}` : '';
  const colCountClass = useWindowWidthResize(handleColCount);
  
  return (
    <>
      {/*<div style={{flex: '.25'}}/>*/}
      {/*<div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(100px, auto))'}}>*/}
      {/*<div>*/}
      <div className={`multiCheckboxContainer ${colCountClass} ${responseClass}`}>
        {
          // responses.map(response=>checkBox(response))
          responses.map(response=>grid(response))
        }
      </div>
      {/*</div>*/}
    </>
  )
}

export default QuestionMultiCheckbox;